import { Text } from "@mantine/core"
import { useTranslation } from "react-i18next"
import { SHORTAGE_REASON_CODES } from "../../../apis/picking-shortage"

/** Shortage reason as plain text. Only the six codes the backend accepts have a name; anything else shows "-". */
export function ShortageReasonBadge({ reasonCode }: Readonly<{ reasonCode: string | null | undefined }>) {
  const { t } = useTranslation("delivery")
  const known = (SHORTAGE_REASON_CODES as readonly string[]).includes(reasonCode ?? "")
  return <Text fz={14}>{known ? t(`shortage.reason.${reasonCode}`) : "-"}</Text>
}
